module.exports = __webpack_public_path__ + "static/img/3.2501a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/3.png
// module id = LB5W
// module chunks = 0